export const FILE_TYPE = {
  IR: 'ir',
  DCBE: 'dcbe',
}
